
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";


export const Vindhyachal=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Vindhyachal Temple, Mirzapur </h1>
           <p className="sub-heading">A Divine Pilgrimage to the Abode of Goddess Vindhyavasini at Mirzapur</p>
         </div>
         <div className="description"> 

Nestled on the banks of the holy River Ganges in Uttar Pradesh, Vindhyachal Temple is one of the most revered Shakti Peethas in India, dedicated to Goddess Vindhyavasini, an incarnation of Goddess Durga. This sacred temple in the Vindhyachal region holds immense spiritual significance and attracts thousands of devotees seeking divine blessings, especially during the grand Navratri festival. According to Hindu mythology, Goddess Vindhyavasini chose this place as her permanent abode after slaying the demon Mahishasura, making it a powerful center of Shakti worship. The temple is part of the Trikona Parikrama pilgrimage, which also includes the Ashtabhuja Temple, dedicated to Goddess Mahasaraswati, and the Kali Khoh Temple, enshrining Goddess Mahakali in a cave. Beyond its religious importance, Vindhyachal offers a mesmerizing blend of nature and spirituality, with scenic ghats and serene landscapes. Visitors can also explore the Sita Kund, believed to be the resting place of Goddess Sita during her exile, and the Rameshwar Mahadev Temple, associated with Lord Rama’s prayers to Lord Shiva. The region’s vibrant marketplaces, filled with religious artifacts and local delicacies, add to the immersive experience. Whether you seek spiritual enlightenment, historical exploration, or a tranquil retreat, Vindhyachal Temple and its surroundings provide a soul-stirring journey into India’s rich cultural and mythological heritage.

  </div>
         <div className="image-gallery">
          
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Vindhyachal/470471841_1123517462665860_6600225164723579087_n.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Vindhyachal/GHV9jWwW0AEerWX.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Vindhyachal/GHV9kpFWYAAn5PB.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Vindhyachal/caption.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Vindhyachal/vindhyachal-sixteen_nine.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Vindhyachal/1672465445_1672465435420.jpg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>

           <div className="image-item">
             <img
                  src={require('../../../media/tourism/other/Vindhyachal/1672465480_img_20221227_074244.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                  src={require('../../../media/tourism/other/Vindhyachal/1701965207_banner_1024x576.jpg.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
        
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                  src={require('../../../media/tourism/other/Vindhyachal/441607111_777812331164527_2297169574347056527_n.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                  src={require('../../../media/tourism/other/Vindhyachal/444481078_775854848026942_3025085871748325057_n.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           
          
         </div>
   
         <BookSection />
       </div>
     );
};